module.exports = __webpack_public_path__ + "static/media/Pic-0371.31673604.jpeg";